/*
 * V2 product page (Neo, 7 Oct 2026).
 * 1. A size must be tapped before anything is added: no silent default size, from the main button,
 *    the sticky bar or the accelerated checkout row.
 * 2. Sticky bar: shows only while the main Add to cart is off screen, hides at the footer.
 * Loaded (defer) from snippets/product-sticky-add-to-cart.liquid.
 */
(() => {
  const root = document.documentElement;
  const sticky = document.querySelector('[data-v2-sticky]');
  const mainForm = document.querySelector('form[id^="product-form-main-"]');
  const formId = sticky ? sticky.dataset.form : mainForm && mainForm.id;
  if (!formId) return;

  const SIZE = '.variant-picker__option[data-option-name="size"]';
  const storeKey = `v2-size-chosen:${formId}`;
  const sizeFieldset = () => document.querySelector(`${SIZE} input[form="${formId}"]`)?.closest(SIZE);
  const needsSize = () => {
    const fieldset = sizeFieldset();
    return !!fieldset && Number(fieldset.dataset.valuesCount) > 1;
  };
  const chosen = () => root.classList.contains('v2-size-chosen');

  const readStore = () => { try { return sessionStorage.getItem(storeKey) === '1'; } catch (e) { return false; } };
  const writeStore = () => { try { sessionStorage.setItem(storeKey, '1'); } catch (e) {} };

  const button = sticky?.querySelector('[data-v2-sticky-button]');
  const syncButton = () => {
    if (!button) return;
    button.textContent = needsSize() && !chosen() ? button.dataset.labelSelect : button.dataset.labelAdd;
  };

  const markChosen = () => {
    root.classList.add('v2-size-chosen');
    root.classList.remove('v2-size-prompt');
    writeStore();
    syncButton();
  };

  let promptTimer;
  const promptSize = () => {
    const fieldset = sizeFieldset();
    if (fieldset) {
      const top = fieldset.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.3;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    root.classList.remove('v2-size-prompt');
    void root.offsetWidth; // restart the nudge animation
    root.classList.add('v2-size-prompt');
    clearTimeout(promptTimer);
    promptTimer = setTimeout(() => root.classList.remove('v2-size-prompt'), 2600);
  };

  if (needsSize()) {
    root.classList.add('v2-size-req');
    if (readStore()) root.classList.add('v2-size-chosen');
  }
  syncButton();

  // A tap on any size (also the one that is already checked) counts as a choice.
  document.addEventListener('click', (event) => {
    const target = event.target.closest?.(`${SIZE} .block-swatch, ${SIZE} input, ${SIZE} .popover__value-option`);
    if (target) markChosen();
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest?.(SIZE) && event.target.getAttribute('form') === formId) markChosen();
  }, true);

  // Block every add without a chosen size. Listeners sit on window in the capture phase, the earliest point an
  // event passes, so they run before the theme's submit handler and before cart apps (Kaching) that catch the tap.
  const isBuyTap = (el) => !!el?.closest?.(
    `.memento-atc-row, .memento-dynamic-checkout-row, button[type="submit"][form="${formId}"], #${CSS.escape(formId)} button[type="submit"]`
  );
  const block = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  window.addEventListener('submit', (event) => {
    if (event.target.id !== formId || !needsSize() || chosen()) return;
    block(event);
    promptSize();
  }, true);

  ['pointerdown', 'touchstart', 'mousedown'].forEach((type) => {
    window.addEventListener(type, (event) => {
      if (needsSize() && !chosen() && isBuyTap(event.target)) event.stopImmediatePropagation();
    }, { capture: true, passive: true });
  });

  window.addEventListener('click', (event) => {
    if (!needsSize() || chosen() || !isBuyTap(event.target)) return;
    block(event);
    promptSize();
  }, true);

  if (!sticky) return;

  button.addEventListener('click', () => {
    if (needsSize() && !chosen()) {
      promptSize();
      return;
    }
    const form = document.getElementById(formId);
    const submitter = document.querySelector(`button[type="submit"][form="${formId}"]`) || form?.querySelector('button[type="submit"]');
    if (form?.requestSubmit) {
      form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
    } else {
      submitter?.click();
    }
  });

  // Visibility: on while the main Add to cart row is out of view, off once the footer arrives.
  let ticking = false;
  const update = () => {
    ticking = false;
    const atc = document.querySelector('.memento-atc-row') || document.getElementById(formId);
    const footer = document.querySelector('.shopify-section--footer, footer');
    const vh = window.innerHeight;
    let on = true;
    if (atc) {
      const r = atc.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) on = false;
    }
    if (footer && footer.getBoundingClientRect().top < vh) on = false;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', String(!on));
  };
  const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('variant:change', () => { syncButton(); schedule(); });

  // Shopify's preview bar (preview links only, never shown to customers) is a fixed 68px layer at the bottom
  // of the screen that covers the sticky bar. Lift the sticky bar above it whenever it is there.
  const liftForPreviewBar = () => {
    const bar = document.getElementById('PBarNextFrameWrapper');
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    sticky.style.insetBlockEnd = h ? `${h}px` : '';
  };
  [0, 800, 2000, 4000, 8000].forEach((t) => setTimeout(liftForPreviewBar, t));
  window.addEventListener('resize', liftForPreviewBar);

  update();
})();
